import { __awaiter } from "tslib";
import { BootstrapError } from './bootstrapError';
import { appendSvgSprites, createSvgSpritesConainer } from './utils';
import { initI18n } from '@shared/lib/Bootstrap/initI18n';
import { clearSvgCacheOnce } from '@shared/lib/svgCache';
import WebskyAnalyticsApollo from '../../../../DataLayerAnalytics/WebskyAnalyticsApollo';
const loadScript = (url) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => resolve(null);
    script.onerror = () => {
        reject(new BootstrapError(`Script load error for: ${url}`));
    };
    document.body.appendChild(script);
});
const loadSvgSprite = (url) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(url);
        const content = yield response.text();
        return content;
        // вставляем svg в начало body
    }
    catch (e) {
        return new BootstrapError(`unable to load engine icons: ${url}`);
    }
});
const addExternalResources = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const { scripts = [], svgs = [] } = options;
    // Параллельно загружаем все скрипты
    if (scripts.length > 0) {
        yield Promise.all(scripts.map((scriptUrl) => __awaiter(void 0, void 0, void 0, function* () {
            yield loadScript(scriptUrl);
        })));
    }
    if (svgs.length > 0) {
        const svgsLoadResults = yield Promise.all(svgs.map((svgUrl) => __awaiter(void 0, void 0, void 0, function* () {
            return yield loadSvgSprite(svgUrl);
        })));
        appendSvgSprites(svgsLoadResults.filter(result => !(result instanceof BootstrapError)));
        const svgsLoadErrors = svgsLoadResults.filter(result => result instanceof BootstrapError);
        if (svgsLoadErrors.length > 0) {
            throw new BootstrapError(svgsLoadErrors.map((error) => error.message).join('\n'));
        }
    }
});
// Функция инициализации приложения
export const bootstrap = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    clearSvgCacheOnce();
    yield initI18n((_a = config === null || config === void 0 ? void 0 : config.global) === null || _a === void 0 ? void 0 : _a.locale);
    if (document.body.querySelector('svg#svgSpritesRoot')) {
        return;
    }
    createSvgSpritesConainer();
    try {
        yield addExternalResources({
            scripts: [
                ...new Set([
                    ...((_c = (_b = config.global.additionalResources) === null || _b === void 0 ? void 0 : _b.scripts) !== null && _c !== void 0 ? _c : []),
                    ...((_e = (_d = config.global.additionalResources) === null || _d === void 0 ? void 0 : _d.extraScripts) !== null && _e !== void 0 ? _e : [])
                ])
            ]
        });
        console.info('All external scripts were loaded successfully.');
    }
    catch (BootstrapError) {
        console.error(BootstrapError);
    }
    try {
        yield addExternalResources({
            svgs: [
                ...new Set([
                    ...((_h = (_g = (_f = config.global) === null || _f === void 0 ? void 0 : _f.additionalResources) === null || _g === void 0 ? void 0 : _g.svgs) !== null && _h !== void 0 ? _h : []),
                    ...((_l = (_k = (_j = config.global) === null || _j === void 0 ? void 0 : _j.additionalResources) === null || _k === void 0 ? void 0 : _k.extraSvgs) !== null && _l !== void 0 ? _l : [])
                ])
            ]
        });
        console.info('All external svg sprites were loaded successfully.');
    }
    catch (BootstrapError) {
        console.error(BootstrapError);
    }
    try {
        WebskyAnalyticsApollo.setUsePixel(config.global.usePixel);
    }
    catch (e) {
        throw new BootstrapError(`${WebskyAnalyticsApollo.name} configuration error`);
    }
});
